/**
 * InputText Component - Template
 * ==============================
 */

export const INPUT_TEXT_TEMPLATE: string = `
<div class="ec-input-text" ng-class="$ctrl.getWrapperClasses()">
  <label
    ng-if="$ctrl.label || $ctrl.hasLabelSlot"
    ng-attr-for="{{ $ctrl.resolvedId }}"
    ng-class="$ctrl.getLabelClasses()"
  ><span ng-if="$ctrl.hasLabelSlot" ng-transclude="labelSlot"></span><span ng-if="!$ctrl.hasLabelSlot">{{ $ctrl.label }}</span></label>

  <div class="ec-flex ec-flex-col ec-gap-1 ec-flex-1 ec-min-w-0">
    <div ng-class="$ctrl.getControlClasses()">
      <input
        ng-attr-id="{{ $ctrl.resolvedId }}"
        ng-attr-type="{{ $ctrl.type }}"
        ng-attr-name="{{ $ctrl.name ? $ctrl.name : undefined }}"
        ng-attr-autocomplete="{{ $ctrl.autocomplete ? $ctrl.autocomplete : undefined }}"
        ng-class="$ctrl.getInputClasses()"
        ng-model="$ctrl.inputValue"
        ng-model-options="{ allowInvalid: true }"
        ng-change="$ctrl.handleInput()"
        ng-disabled="$ctrl.disabled"
        placeholder="{{ $ctrl.placeholder }}"
        ng-attr-aria-invalid="{{ $ctrl.error ? 'true' : undefined }}"
        ng-attr-aria-describedby="{{ ($ctrl.helpMessage || $ctrl.hasHelpSlot) ? $ctrl.helpId : undefined }}"
      />
      <span
        ng-if="$ctrl.hasIcon"
        ng-class="$ctrl.getIconClasses()"
        ng-bind-html="$ctrl.trustedIcon"
        aria-hidden="true"
      ></span>
    </div>

    <span
      ng-if="($ctrl.helpMessage || $ctrl.hasHelpSlot) && $ctrl.labelPosition !== 'inline'"
      ng-attr-id="{{ $ctrl.helpId }}"
      ng-class="$ctrl.getHelpClasses()"
    ><span ng-if="$ctrl.hasHelpSlot" ng-transclude="helpSlot"></span><span ng-if="!$ctrl.hasHelpSlot">{{ $ctrl.helpMessage }}</span></span>
  </div>
</div>
`;

export default INPUT_TEXT_TEMPLATE;
